import script from "./TaskAdditionalWorkTypes.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskAdditionalWorkTypes.vue?vue&type=script&setup=true&lang=ts"

import "./TaskAdditionalWorkTypes.vue?vue&type=style&index=0&id=560cb534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560cb534"]])

export default __exports__